import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {TextBox} from '../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroup} from '../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {ButtonGroupSpacer} from '../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {Dialog} from '../../../components/common/dialogs/dialog';
import {DialogContent} from '../../../components/common/dialogs/dialogContent';
import {DialogFooter} from '../../../components/common/dialogs/dialogFooter';
import {DialogHeader} from '../../../components/common/dialogs/dialogHeader';

/*
 * Constants.
 */

const stringToDisableIntegration = 'DISABLE';

/*
 * Props.
 */

interface SettingsAppsDisableIntegrationDialogProps {
  onRequestClose: Handler;
  onDisableIntegration: Handler;
}

/*
 * Component.
 */

export const SettingsAppsDisableIntegrationDialog: FC<SettingsAppsDisableIntegrationDialogProps> = (
  props,
) => {
  const {onRequestClose, onDisableIntegration} = props;
  const [disableValue, setDisableValue] = useState('');

  return (
    <Dialog onRequestClose={onRequestClose}>
      <DialogHeader
        title={<Trans id="settings-apps-details-disable-integration-dialog-title">Disable app</Trans>}
        onRequestClose={onRequestClose}
      />
      <DialogContent>
        <Trans id="settings-apps-details-disable-integration-dialog-description">
          Are you sure you want to disable this plugin for your company? Doing so will remove the plugin for
          you and all other teammates currently using it. Type {stringToDisableIntegration} to confirm this
          action.
        </Trans>
        <TextBox value={disableValue} onChange={setDisableValue} placeholder={stringToDisableIntegration} />
      </DialogContent>
      <DialogFooter>
        <ButtonGroupSpacer />
        <ButtonGroup>
          <Button onClick={onRequestClose}>
            <Trans id="settings-apps-details-disable-integration-dialog-cancel-action">Cancel</Trans>
          </Button>
          <Button
            variant={ButtonVariantsEnum.DANGER}
            isDisabled={disableValue !== stringToDisableIntegration}
            onClick={onDisableIntegration}
          >
            <Trans id="settings-apps-details-disable-integration-dialog-primary-action">Disable app</Trans>
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </Dialog>
  );
};
